import "./App.css";
import React, { useState, useEffect } from "react";
import CommonLayout from "./layout/CommonLayout";
import { RoleProvider } from "./utils/RoleContext";
import useAuth from "./hooks/useAuth";
import Loader from "./utils/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import { AppProvider } from "./utils/AppContext";




function App() {
  const { loading, isLoggedin, user } = useAuth();
  const [userData, setUserData] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();



  useEffect(() => {
    try {
      const sessionUser = sessionStorage.getItem("user");
      setUserData(user || (sessionUser ? JSON.parse(sessionUser) : null));
    } catch (e) {
      console.error("Failed to parse session user:", e);
      setUserData(null);
    }
  }, [user, loading, isLoggedin]);

  useEffect(() => {
    if (!userData) {
      const timeout = setTimeout(() => {
        navigate("/not-found");
      }, 15000);

      return () => clearTimeout(timeout); // cleanup on re-render/unmount
    }
  }, [userData, navigate]);

  if (location.pathname !== "/not-found" && (loading || !isLoggedin || !userData)) {
    return <Loader />;
  }

  return (
    <AppProvider>
      <RoleProvider userRole={userData?.role}>
        <CommonLayout userData={userData} />
      </RoleProvider>
    </AppProvider>
  );

}

export default App;
